import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Meta from "../Meta";
import Loader from "../loader";
import { t } from "@lingui/core/macro";
import { applyLang } from "../../../i18n";
import { ASSET_URL } from "../../../config";
import {
    KosherPlacesGrid,
    HotelsGrid,
    HotelsList,
    AttractionsGrid,
    Services,
    EventsStrip,
    ArticlesStrip,
    JourneyCTA,
    AiContentSlot,
    Banners,
} from "../ui-components";
import {travelBannersPlacement} from '../../../components/travelHomepage';
import InfoTiles from "../ui-components/InfoTiles";
import { getBethHabadLabel } from "../utils";

export default function Home({ context, loading }) {
    const { org, config, travel } = context;

    const slides = travel?.heroBanner?.slides || [];
    const aiContentBlockId = travel?.homepage?.aiContentBlockId || null;
    const firstSlide = slides[0] ? applyLang(slides[0], context.lang) : null;
    const bethHabadLabel = getBethHabadLabel(travel, context.lang);

    const heroImage = firstSlide?.image
        ? (/^https?:\/\//.test(firstSlide.image) ? firstSlide.image : `${ASSET_URL}${firstSlide.image}`)
        : null;

    const description =
        firstSlide?.description ||
        config["meta.description"] ||
        t`Bienvenue sur le ${bethHabadLabel} touristique de ${org.name}`;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: org.name,
        url: org.BASE_WEB_URL || undefined,
        logo: org.logo ? (org.logo.startsWith("http") ? org.logo : `${ASSET_URL}${org.logo}`) : undefined,
        address: org.ville ? { "@type": "PostalAddress", addressLocality: org.ville } : undefined,
    };

    return (
        <div className="travel-page travel-page--home">
            <Meta
                context={context}
                title={org.name}
                description={description}
                image={heroImage}
                jsonLd={jsonLd}
            />

            {loading && <Loader />}

            <Header context={context} />

            <main className="travel-main">
                <Hero slides={slides} />

                {travelBannersPlacement(travel) === 'top' && <Banners context={context} />}

                {aiContentBlockId && <AiContentSlot blockId={aiContentBlockId} lang={context.lang?.value || context.lang} />}

                <InfoTiles context={context} />

                <JourneyCTA context={context} />

                <KosherPlacesGrid context={context} />

                <HotelsGrid context={context} />

                <AttractionsGrid context={context} />

                <Services context={context} />

                <EventsStrip context={context} />

                <ArticlesStrip context={context} />
            </main>

            <Footer context={context} />
        </div>
    );
}
